/**
   * Class for reading the hash value from the URL and activating the wrapping that contains the element with the matching ID.
   * By now, it can be used for the Accordion and Tabs components.
   * Elements can be nested, e.g. a Accordion can be inside a Tab. In that case, both will be activated.
   *
   * @param {element} el The component element
   * @param {string} type The type of the component
   * @param {object} traversingElements CSS Classes of the anchor-points needed for traversion
   * @var {number} maxTraversions Maximum number of traversions through the DOM before the operation is cancelled
   */

export default class ContentRouter {
  constructor (el, type, traversingElements) {
    this.el = el
    this.type = type
    this.traversingElements = traversingElements
    this.maxTraversions = 1000
  }

  // Match the window hash to the type of the element
  matchHashToType () {
    if (this.checkHash()) {
      let hash = window.location.hash.substr(1)
      let targetElement = document.getElementById(hash)
      // let targetElement = this.el.querySelector(`#${CSS.escape(hash)}`);

      if (targetElement) {
        switch (this.type) {
          case 'accordion':
            this.findClickableAccordion(targetElement)
            break
          case 'tabs':
            this.findClickableTab(targetElement)
            break
          default:
            throw new Error('No correct type of routing element was delivered')
        }
      }
    }
  }

  // Check if a hash is set
  checkHash () {
    if (window.location.hash !== '') {
      return true
    }
  }

  // Function to find the accordion trigger counterpart to the element in which the ID was found
  findClickableAccordion (targetElement) {
    let counter = 0
    let lastTarget

    const innerTraverse = (targetElement) => {
      if (counter < this.maxTraversions) {
        counter++
        if (targetElement) {
          if (targetElement.classList.contains(this.traversingElements.clickable)) {
            this.activateTarget(targetElement)
            return
          }
          lastTarget = targetElement
          targetElement = targetElement.previousElementSibling
          innerTraverse(targetElement)
        } else {
          outerTraverse(lastTarget)
        }
      } else {
        return
      }
    }

    const outerTraverse = (targetElement) => {
      targetElement = targetElement.parentElement
      innerTraverse(targetElement)
    }
    innerTraverse(targetElement)
  }

  // Function to find the tab trigger counterpart to the element in which the ID was found
  findClickableTab (targetElement) {
    const getTargetTabIndex = () => {
      const tabs = this.el.querySelectorAll('.' + this.traversingElements.parent) // generisch, reingeben, etc
      let tabIndex
      for (let index = 0; index < tabs.length; index++) {
        if (tabs[index].contains(targetElement)) {
          tabIndex = index
          break
        }
      }
      return tabIndex
    }

    const getTabTrigger = () => {
      const triggers = this.el.querySelectorAll('.' + this.traversingElements.clickable)
      this.activateTarget(triggers[getTargetTabIndex()])
    }
    getTabTrigger()
  }

  // Function for clicking the trigger to activate the target, thus show the container with the target ID
  // You can also use this function from outside from the initialized object to click some triggers
  activateTarget (activator) {
    let setClickTarget = new Promise((resolve, reject) => {
      let clickTarget = activator
      if (clickTarget) {
        resolve(clickTarget)
      }
    })

    setClickTarget.then((clickTarget) => {
      setTimeout(() => {
        if (!clickTarget.classList.contains('auto-clicked')) { // very simple mechanism to prevent multiple clicks. Whole tab/accordion auto-open should be rewritten in the future
          clickTarget.scrollIntoView()
          clickTarget.click()
          clickTarget.classList.add('auto-clicked')
        }
      }, 200)
    })
  }

  // Initializing function
  init () {
    window.addEventListener('hashchange', () => {
      this.matchHashToType()
    })

    this.matchHashToType()
  }
}
